<template>
  <div class="left">
    <div class="menu">
      <span class="spen">{{ $t('left_menu.Order_Center') }}</span>
      <ul class="ul">
        <router-link :to="{ name: 'Dingdan' }" tag="li">{{ $t('left_menu.My_Orders') }}</router-link>
        <router-link :to="{ name: 'Shaidan' }" tag="li">{{ $t('left_menu.My_Reviews') }}</router-link>
        <router-link :to="{ name: 'Changgou' }" tag="li">{{ $t('left_menu.My_Habits') }}</router-link>
      </ul>
    </div>
    <div class="menu">
      <span class="spen">{{ $t('left_menu.Asset_Center') }}</span>
      <ul class="ul">
        <router-link :to="{ name: 'Yue' }" tag="li">{{ $t('left_menu.My_Balance') }}</router-link>
        <router-link :to="{ name: 'Youhui' }" tag="li">{{ $t('left_menu.My_Coupon') }}</router-link>
        <router-link :to="{ name: 'Shouxin' }" tag="li">{{ $t('left_menu.My_Credit_Line') }}</router-link>
        <router-link :to="{ name: 'Shopcard' }" tag="li">{{ $t('left_menu.My_Gift_Card') }}</router-link>
        <!--        <li>积分</li>-->
        <router-link :to="{ name: 'Jifen' }" tag="li">{{ $t('left_menu.My_Points') }}</router-link>
      </ul>
    </div>
    <div class="menu">
      <span class="spen">{{ $t('left_menu.Customer_Service') }}</span>
      <ul class="ul">
        <!-- <router-link :to="{ name: 'Tuihuo' }" tag="li">退换货</router-link> -->
        <router-link :to="{ name: 'Fapiao' }" tag="li">{{ $t('left_menu.My_Invoice') }}</router-link>
        <!--客户经理显示-->
        <router-link :to="{ name: 'HuiYuan' }" tag="li" v-if="isManager">{{ $t('left_menu.My_VIPS') }}</router-link>
        <router-link :to="{ name: 'MdingDan' }" tag="li" v-if="isManager">{{ $t('left_menu.My_Indent_Orders') }}</router-link>
        <router-link :to="{ name: 'ShenHe' }" tag="li" v-if="isManager">{{ $t('left_menu.My_Order_Review') }}</router-link>
        <!--普通会员显示-->
        <!--<router-link :to="{ name: 'MdingDan' }" tag="li" v-if="!isManager">我的代购订单</router-link>-->
      </ul>
    </div>
    <div class="menu">
      <span class="spen">{{ $t('left_menu.Following_Center') }}</span>
      <ul class="ul">
        <router-link :to="{ name: 'wares' }" tag="li">{{ $t('left_menu.My_Followed_Products') }}</router-link>
        <router-link :to="{ name: 'store' }" tag="li">{{ $t('left_menu.My_Followed_Stores') }}</router-link>
        <!-- <router-link :to="{ name: 'route' }" tag="li">我的足迹</router-link> -->
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
    <div class="menu">
      <span class="spen">{{ $t('left_menu.Account_Settings') }}</span>
      <ul class="ul">
        <router-link :to="{ name: 'User' }" tag="li">{{ $t('left_menu.My_Personal_Information') }}</router-link>
        <router-link :to="{ name: 'Safe' }" tag="li">{{ $t('left_menu.My_Account_Security') }}</router-link>
        <router-link :to="{ name: 'Bind' }" tag="li">{{ $t('left_menu.My_Account_Linking') }}</router-link>
        <router-link :to="{ name: 'Address' }" tag="li">{{ $t('left_menu.My_Shipping_Address') }}</router-link>
      </ul>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/utils/cookie'

export default {
  data() {
    return {
      isManager: false
    }
  },
  created() {
    const managerType = getCookie('managerType')
    if (managerType == '') {
      this.isManager = false
    } else if (managerType == 'null') {
      this.isManager = false
    } else if (managerType == '0') {
      this.isManager = false
    } else {
      this.isManager = true
    }
  }
}
</script>
<style lang="scss" scoped>
li {
  list-style: none;
}
.left {
  width: 155px;
  background: #fff;
  .menu {
    padding: 36px 0;
    padding-left: 30px;
    border-bottom: 1px solid #ededed;
    .spen {
      font-size: 18px;
      color: #333;
      font-weight: 600;
    }
    .ul {
      font-size: 15px;
      color: #333;
      padding: 0;
      li {
        margin-top: 10px;
        list-style: none;
        cursor: pointer;
        &.router-link-exact-active.router-link-active {
          color: #3661fe;
        }
      }
    }
    .bian {
      color: #1a52ff;
    }
  }
}
</style>
